import LoggerService,{formatTrace,formatInfo} from '../../LoggerService';
import {_checkTokens,_checkErrors,_tryOrRefresh,I_COMMON_GET_ALL_PARAMS,I_COMMON_DELETE_PARAMS} from './_base';

import I_TASK_TYPE from '../interfaces/I_TASK_TYPES';
import {
  getTaskTypesResponse,
  postTaskTypeResponse,
  deleteTaskTypeResponse,
  putTaskTypeResponse,
} from '../ApiEndpoints';

// ---------------------------------
// --- TASK TYPES
// ---------------------------------

const logger = LoggerService.getInstance();

/**
 * Récupère la liste des types de tache
 * @param obj
 * @returns
 */
const getList = async ({accessToken,refreshToken,dispatch,state}:I_COMMON_GET_ALL_PARAMS):Promise<I_TASK_TYPE[]> => {
  logger.debug('ApiServices - getTaskTypes - ...');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return getTaskTypesResponse({accessToken:usedAccessToken});
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,
    state,
  });
  logger.trace(...formatTrace('ApiServices - getTaskTypes - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:I_TASK_TYPE[] = await response.json();
  logger.debug('ApiServices - getTaskTypes - ok, returned body',body);
  return body;
};

interface I_CREATE_TASK_TYPE_PARAMS {
  accessToken?: string,
  refreshToken?: string,
  name: string,
  description: string,
  dispatch: any; // on a besoin du dispatch pour store les tokens en cas de refresh
  state: any; // on a besoin du state pour comparer les tokens en cas de 401
}
/**
 * Crée un type de tache
 * @param param0
 * @returns
 */
const create = async ({accessToken,refreshToken,name,description,dispatch,state}:I_CREATE_TASK_TYPE_PARAMS):Promise<string> => {
  logger.debug('ApiServices - createTaskType - ...');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // pre-verification qu'on a bien des valeurs obligatoires, sinon sert a rien de faire la requete
  if (!description) {
    description = '';
  }
  if (
    !name || name === null || name.trim() === '' ||
    description === undefined || description === null // description pas obligatoire
  ) {
    const error = {
      error: true,
      errorCode: 1000,
      errorText: 'Missing name or description or parentID',
      errorMessage: 'Missing name or description or parentID to post task type',
    };
    return Promise.reject(error);
  }
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return postTaskTypeResponse({accessToken:usedAccessToken,name,description});
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - createTaskType - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:string = await response.text();
  logger.debug('ApiServices - getTaskTypes - ok, returned body',body);
  logger.info(...formatInfo('Task type created!'));
  return body;
};

/**
 * Supprime un type de tache
 * @param param0
 * @returns
 */
const remove = async ({accessToken,refreshToken,id,dispatch,state}:I_COMMON_DELETE_PARAMS):Promise<string> => {
  logger.debug('ApiServices - deleteTaskType - ...');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return deleteTaskTypeResponse({accessToken:usedAccessToken,id});
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - deleteTaskType - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:string = await response.text();
  logger.debug('ApiServices - deleteTaskType - ok, returned body',body);
  logger.info(...formatInfo('Task type deleted!'));
  return body;
};

interface I_PUT_TASK_TYPE_PARAMS {
  accessToken?: string,
  refreshToken?: string,
  id: number,
  name: string,
  description: string,
  dispatch: any; // on a besoin du dispatch pour store les tokens en cas de refresh
  state: any; // on a besoin du state pour comparer les tokens en cas de 401
}
/**
 * Modifie un type de tache
 * @param param0
 * @returns
 */
const update = async ({accessToken,refreshToken,id,name,description,dispatch,state}:I_PUT_TASK_TYPE_PARAMS):Promise<string> => {
  logger.debug('ApiServices - updateTaskType - ...');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // pre-verification qu'on a bien des valeurs obligatoires, sinon sert a rien de faire la requete
  if (
    id === undefined || id === null ||
    !name || name === null || name.trim() === '' ||
    description === undefined || description === null // description pas obligatoire
  ) {
    const error = {
      error: true,
      errorCode: 1000,
      errorText: 'Missing id, name, description or parentID',
      errorMessage: 'Missing id, name, description or parentID to put task type',
    };
    return Promise.reject(error);
  }
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return putTaskTypeResponse({accessToken:usedAccessToken,id,name,description});
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - updateTaskType - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:string = await response.text();
  logger.debug('ApiServices - updateTaskType - ok, returned body',body);
  logger.info(...formatInfo('Task type updated!'));
  return body;
};

const taskTypesServices = {
  getList,
  create,
  remove,
  update,
};

export default taskTypesServices;
